import { Component, Input, OnInit } from '@angular/core';
import { LineInterface } from '../../../../lines/models/line.interface';
import { Store } from '@ngrx/store';
import { UpdateSelectedProcedure } from '../../../store/actions/selected-procedure.actions';
import { SaveMission } from '../../../store/actions/mission.actions';
import { PriceDetailsInterface } from '../../../models/price-details.interface';

@Component({
    selector: 'app-activation-five-g',
    templateUrl: './activation-five-g.component.html',
    styleUrls: ['./activation-five-g.component.css'],
    standalone: false
})
export class ActivationFiveGComponent implements OnInit {

  @Input()
  line: LineInterface;

  @Input()
  procedureCode: string;

  @Input()
  priceDetails?: PriceDetailsInterface;

  active: boolean;
  formSubmitted: boolean;

  constructor(private store: Store<any>) {}

  selectedPhoneModel: string;
  displayTypeError: boolean;
  phoneModels = [
    {model:'Apple iPhone SE 3ème génération'},
    {model:'Apple iPhone 12'},
    {model:'Apple iPhone 12 Mini'},
    {model:'Apple iPhone 12 Pro'},
    {model:'Apple iPhone 12 Pro Max'},
    {model:'Apple iPhone 13'},
    {model:'Apple iPhone 13 Mini'},
    {model:'Apple iPhone 13 Pro'},
    {model:'Apple iPhone 13 Pro Max'},
    {model:'Apple iPhone 14'},
    {model:'Apple iPhone 14 Plus'},
    {model:'Apple iPhone 14 Pro'},
    {model:'Apple iPhone 14 Pro Max'},
    {model:'Apple iPhone 15'},
    {model:'Apple iPhone 15 Plus'},
    {model:'Apple iPhone 15 Pro'},
    {model:'Apple iPhone 15 Pro Max'},
    {model:'Crosscall Core-Z5'},
    {model:'Crosscall Stellar-X5'},
    {model:'Fairphone 4 5G'},
    {model:'Fairphone 5 5G'},
    {model:'Google Pixel 4A 5G'},
    {model:'Google Pixel 5 5G'},
    {model:'Google Pixel 6 5G'},
    {model:'Google Pixel 6A 5G'},
    {model:'Google Pixel 6 Pro 5G'},
    {model:'Google Pixel 7 5G'},
    {model:'Google Pixel 7A 5G'},
    {model:'Google Pixel 7 Pro 5G'},
    {model:'Google Pixel 8 5G'},
    {model:'Google Pixel 8 Pro 5G'},
    {model:'Honor 50 5G'},
    {model:'Honor 70 5G'},
    {model:'Honor 70 Lite 5G'},
    {model:'Honor 90 5G'},
    {model:'Honor 90 Lite 5G'},
    {model:'Honor x8 5G'},
    {model:'Honor Magic4 Pro 5G'},
    {model:'Honor Magic4 Lite 5G'},
    {model:'Honor Magic5 Lite 5G'},
    {model:'Honor Magic5 Pro 5G'},
    {model:'Honor Magic VS 5G'},
    {model:'Huawei Mate 20X 5G'},
    {model:'Huawei Mate 40 Pro 5G'},
    {model:'Huawei Mate XS 5G'},
    {model:'Huawei P40 5G'},
    {model:'Huawei P40 Lite 5G'},
    {model:'Huawei P40 Pro 5G'},
    {model:'Motorola Edge 40 Neo'},
    {model:'Motorola Razr 40'},
    {model:'Motorola Moto g84 5G'},
    {model:'Motorola Moto g53 5G'},
    {model:'Oppo Find N2 Flip'},
    {model:'Oppo Find X2 Lite 5G'},
    {model:'Oppo Find X2 Neo 5G'},
    {model:'Oppo Find X2 Pro 5G'},
    {model:'Oppo Find X3 Lite 5G'},
    {model:'Oppo Find X3 Neo 5G'},
    {model:'Oppo Find X3 Pro 5G'},
    {model:'Oppo Find X5 5G'},
    {model:'Oppo Find X5 Lite 5G'},
    {model:'Oppo Find X5 Neo 5G'},
    {model:'Oppo Find X5 Pro 5G'},
    {model:'Oppo Reno4 5G'},
    {model:'Oppo Reno4 Z 5G'},
    {model:'Oppo Reno4 Pro 5G'},
    {model:'Oppo Reno6 5G'},
    {model:'Oppo Reno6 Pro 5G'},
    {model:'Oppo Reno8 5G'},
    {model:'Oppo Reno8 Lite 5G'},
    {model:'Oppo Reno8 Pro 5G'},
    {model:'Oppo A54 5G'},
    {model:'Oppo A74 5G'},
    {model:'Oppo A77 5G'},
    {model:'Oppo A94 5G'},
    {model:'Samsung Galaxy A13 5G'},
    {model:'Samsung Galaxy A14 5G'},
    {model:'Samsung Galaxy A22 5G'},
    {model:'Samsung Galaxy A23 5G'},
    {model:'Samsung Galaxy A32 5G'},
    {model:'Samsung Galaxy A33 5G'},
    {model:'Samsung Galaxy A34 5G'},
    {model:'Samsung Galaxy A42 5G'},
    {model:'Samsung Galaxy A51 5G'},
    {model:'Samsung Galaxy A52 5G'},
    {model:'Samsung Galaxy A52s 5G'},
    {model:'Samsung Galaxy A53 5G'},
    {model:'Samsung Galaxy A54 5G'},
    {model:'Samsung Galaxy Note 10+ 5G'},
    {model:'Samsung Galaxy Note 20 5G'},
    {model:'Samsung Galaxy Note 20 Ultra 5G'},
    {model:'Samsung Galaxy S10 5G'},
    {model:'Samsung Galaxy S20 5G'},
    {model:'Samsung Galaxy S20 FE 5G'},
    {model:'Samsung Galaxy S20+ 5G'},
    {model:'Samsung Galaxy S20 Ultra 5G'},
    {model:'Samsung Galaxy S21 5G'},
    {model:'Samsung Galaxy S21 FE 5G'},
    {model:'Samsung Galaxy S21+ 5G'},
    {model:'Samsung Galaxy S21 Ultra 5G'},
    {model:'Samsung Galaxy S22 5G'},
    {model:'Samsung Galaxy S22+ 5G'},
    {model:'Samsung Galaxy S22 Ultra 5G'},
    {model:'Samsung Galaxy S23 5G'},
    {model:'Samsung Galaxy S23 FE 5G'},
    {model:'Samsung Galaxy S23+ 5G'},
    {model:'Samsung Galaxy S23 Ultra 5G'},
    {model:'Samsung Galaxy Z Flip 5G'},
    {model:'Samsung Galaxy Z Flip 3 5G'},
    {model:'Samsung Galaxy Z Flip 4 5G'},
    {model:'Samsung Galaxy Z Flip 5 5G'},
    {model:'Samsung Galaxy Z Fold 2 5G'},
    {model:'Samsung Galaxy Z Fold 3 5G'},
    {model:'Samsung Galaxy Z Fold 4 5G'},
    {model:'Samsung Galaxy Z Fold 5 5G'},
    {model:'Sony Xperia 1 II 5G'},
    {model:'Sony Xperia 1 III 5G'},
    {model:'Sony Xperia 1 IV 5G'},
    {model:'Sony Xperia 5 II 5G'},
    {model:'Sony Xperia 5 III 5G'},
    {model:'Sony Xperia 5 IV 5G'},
    {model:'Sony Xperia 10 III 5G'},
    {model:'Sony Xperia 10 IV 5G'},
    {model:'Vivo V21 5G'},
    {model:'Vivo V23 5G'},
    {model:'Vivo Y52 5G'},
    {model:'Vivo Y55 5G'},
    {model:'Vivo Y72 5G'},
    {model:'Vivo Y76 5G'},
    {model:'Xiaomi 11T 5G'},
    {model:'Xiaomi 11T Pro 5G'},
    {model:'Xiaomi 12 5G'},
    {model:'Xiaomi 12 Pro 5G'},
    {model:'Xiaomi 12T 5G'},
    {model:'Xiaomi 12T Pro 5G'},
    {model:'Xiaomi 12 Lite 5G'},
    {model:'Xiaomi 13 5G'},
    {model:'Xiaomi 13 Lite 5G'},
    {model:'Xiaomi 13 Pro 5G'},
    {model:'Xiaomi 13T 5G'},
    {model:'Xiaomi 13T Pro 5G'},
    {model:'Xiaomi Mi 10 5G'},
    {model:'Xiaomi Mi 10 Lite 5G'},
    {model:'Xiaomi Mi 10 Pro 5G'},
    {model:'Xiaomi Mi 10T 5G'},
    {model:'Xiaomi Mi 10T Lite 5G'},
    {model:'Xiaomi Mi 10T Pro 5G'},
    {model:'Xiaomi Mi 11 5G'},
    {model:'Xiaomi Mi 11i 5G'},
    {model:'Xiaomi Mi 11 Lite 5G'},
    {model:'Xiaomi Mi 11 Ultra 5G'},
    {model:'Xiaomi Mi 11 Pro 5G'},
    {model:'Xiaomi Mi 11T 5G'},
    {model:'Xiaomi Mi 11T Pro 5G'},
    {model:'Xiaomi Mi 12 5G'},
    {model:'Xiaomi Mi 12 Pro 5G'},
    {model:'Xiaomi Mi 12T 5G'},
    {model:'Xiaomi Mi 12T Pro 5G'},
    {model:'Xiaomi Mi Mix 3 5G'},
    {model:'Xiaomi Redmi Note 9T 5G'},
    {model:'Xiaomi Redmi Note 10 5G'},
    {model:'Xiaomi Redmi Note 11 5G'},
    {model:'Xiaomi Redmi Note 11s 5G'},
    {model:'Xiaomi Redmi Note 11 Pro 5G'},
    {model:'Xiaomi Redmi Note 11 Pro+ 5G'},
    {model:'Xiaomi Redmi Note 12 5G'},
    {model:'Xiaomi Redmi Note 12 Pro 5G'},
    {model:'Xiaomi Redmi Note 12 Pro+ 5G'},
    {model:'Xiaomi Redmi 12 5G'}
  ];

  ngOnInit() {
    this.selectedPhoneModel = null;
    this.displayTypeError = false;
    this.formSubmitted = false;
    this.active = this.line.optionsStatus.toggle_5g;
  }

  setSelectedType(event) {
    this.selectedPhoneModel = event.target.value;
    this.displayTypeError = event.target.value === '';
  }

  cancel() {
    this.store.dispatch(new UpdateSelectedProcedure(''));
  }

  confirmation() {
    if (this.active) {
      this.selectedPhoneModel = null;
      this.displayTypeError = false;
    } else {
      if (this.active === false && (this.selectedPhoneModel === null || this.selectedPhoneModel === '')) {
        this.displayTypeError = true;
      } else {
        this.displayTypeError = false;
      }
    }
    if (this.displayTypeError === false && this.formSubmitted === false) {
      this.formSubmitted = true;
      this.store.dispatch(new SaveMission({step: 1, model: this.selectedPhoneModel, active: !this.active, phoneNumber: this.line.phoneNumber}, this.procedureCode));
    }
  }
}
